module.exports = __webpack_public_path__ + "media/images/markers/fixed-cc35f4478ae1359edc0212f47a8f2c88.png";